// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 图片分类
import PictureType from '@/views/miniBase/PictureType';
// 小程序用户
import MiniUser from '@/views/miniBase/MiniUser';
// 小程序用户角色
import MiniUserRole from '@/views/miniBase/MiniUserRole';
// 小程序样式
import MiniStyle from '@/views/miniBase/MiniStyle';



/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
// 权限管理
import TaskCron from '@/views/system/TaskCron';

/**
 * 小程序业务数据
 */
//图片组评论
import Comment from '@/views/miniBusiness/CommentAll'
//预览图管理
import Thumbnail from '@/views/miniBusiness/Thumbnail'
//违规评论管理
import IllegalComment from '@/views/miniBusiness/IllegalComment'
//用户访问记录
import VisitLog from '@/views/miniBusiness/VisitLog'


// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBase/MiniUser',
            name: '小程序用户',
            component: MiniUser,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBase/MiniUserRole',
            name: '小程序用户角色',
            component: MiniUserRole,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBase/PictureType',
            name: '图片分类',
            component: PictureType,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/TaskCron',
            name: '系统任务',
            component: TaskCron,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBase/MiniStyle',
            name: '小程序样式',
            component: MiniStyle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBusiness/CommentAll',
            name: '所有评论',
            component: Comment,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBusiness/Thumbnail',
            name: '预览图管理',
            component: Thumbnail,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBusiness/IllegalComment',
            name: '违规评论管理',
            component: IllegalComment,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/miniBusiness/VisitLog',
            name: '用户访问记录',
            component: VisitLog,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js